var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.6667V13.6667L10.6667 11L0 8.33337V0.333374L25.3333 11L0 21.6667Z",
    fill: "url(#paint0_linear_4489_2962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4489_2962",
    x1: 0,
    y1: 11,
    x2: 25.3333,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221933,
    stopColor: "#066094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AEBD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendImage);
export default __webpack_public_path__ + "static/media/sendImage.4fc5aab9e94c65ce3ad9cbc90227a142.svg";
export { ForwardRef as ReactComponent };